import { validateQueryParams } from '../../utils/api/api-utils';
import {
  doGetQCXRequest,
  doPostQCXRequest,
  doPutQCXActivateRequest,
  doPutQCXInactivateRequest,
  doPutQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import { FILTER_ENDPOINT, INCOTERM_CONDICAO_DE_VENDA_ENDPOINT } from '../../utils/api/domain/domain-endpoint-utils';

export async function fetchAll() {
  return doGetQCXRequest([
    INCOTERM_CONDICAO_DE_VENDA_ENDPOINT
  ]);
}
export async function fetchByFilter(params = []) {
  const validatedParams = validateQueryParams(params);
  if (validatedParams.length) {
    return doGetQCXRequest([
      INCOTERM_CONDICAO_DE_VENDA_ENDPOINT, FILTER_ENDPOINT
    ], validatedParams);
  }
  return { data: [] };
}

export async function fetchById(id) {
  return doGetQCXRequest([
    INCOTERM_CONDICAO_DE_VENDA_ENDPOINT,
    id
  ]);
}

export async function register(data) {
  return doPostQCXRequest(
    [INCOTERM_CONDICAO_DE_VENDA_ENDPOINT],
    data
  );
}

export async function save(data) {
  return doPutQCXRequest(
    [INCOTERM_CONDICAO_DE_VENDA_ENDPOINT],
    data
  );
}

export async function activateById(id) {
  return doPutQCXActivateRequest(
    [INCOTERM_CONDICAO_DE_VENDA_ENDPOINT],
    id
  );
}

export async function inactivateById(id) {
  return doPutQCXInactivateRequest(
    [INCOTERM_CONDICAO_DE_VENDA_ENDPOINT],
    id
  );
}
